import React from 'react';

function matchesLiteGraphics() {
  if (typeof window === 'undefined') return true;
  return (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    window.matchMedia('(max-width: 767px)').matches
  );
}

/**
 * Lighter hero ribbons on small screens; pause motion when the hero is off-screen.
 */
export function useProductsHeroGraphics() {
  const artRef = React.useRef(null);
  const [liteGraphics, setLiteGraphics] = React.useState(false);
  const [artPaused, setArtPaused] = React.useState(false);

  React.useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const narrow = window.matchMedia('(max-width: 767px)');
    const onChange = () => setLiteGraphics(matchesLiteGraphics());
    onChange();
    reducedMotion.addEventListener('change', onChange);
    narrow.addEventListener('change', onChange);
    return () => {
      reducedMotion.removeEventListener('change', onChange);
      narrow.removeEventListener('change', onChange);
    };
  }, []);

  React.useEffect(() => {
    const el = artRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setArtPaused(!entry.isIntersecting),
      { root: null, rootMargin: '64px 0px', threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { artRef, liteGraphics, artPaused };
}
